import { GroupFilled } from "@clockwise/icons";
import { Avatar, Badge } from "@material-ui/core";
import classNames from "classnames";
import React from "react";

export const BulkIconAvatar = () => {
  return (
    <Badge
      overlap="circular"
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      showZero={false}
      className="cw-p-0"
    >
      <Avatar
        alt={"groupicon"}
        src={undefined}
        style={{
          width: 30,
          height: 30,
        }}
        className={classNames(
          "cw-text-onEmphasis cw-bg-brand-emphasis cw-text-12 cw-bg-busy-inset",
        )}
      >
        <GroupFilled className="cw-h-4 cw-w-4 cw-text-busy-muted" />
      </Avatar>
    </Badge>
  );
};
